// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"movie_wrapper__A8gdc","slide":"movie_slide__3KuBO","movie":"movie_movie__2OdUT"};